module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedBlack.9a0cd1a.woff";